<template lang="pug">
	div.container-fluid
		router-view
</template>

<script>
import { mapMutations } from 'vuex'
export default {
	created () {
		const menu = [
			{
				'icono': 'fa fa-map',
				'nombre': 'Mapa',
				activo: false,
				callback: (a) => {
					this.setMenuActivo(a)
					this.$router.push('/main/control-emisoras/mapa')
				}
			}
		]
		this.setMenu(menu)
	},
	methods: {
		...mapMutations({
			setMenu: 'top/setMenu',
			setMenuActivo: 'top/setMenuActivo',
			clearMenu: 'top/clearMenu'
		})
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/control-emisoras/vue/Main.vue